// Faqs.jsx
import React, { useState } from "react";
import "../App.css";

const faqs = [
  {
    question: "What is AlgoHeads?",
    answer:
      "AlgoHeads is a job referral intelligence tool that helps you discover job openings at companies where your LinkedIn connections already work—so you can directly reach out for a referral.",
  },
  {
    question: "How does AlgoHeads find relevant job openings for me?",
    answer:
      "You upload your LinkedIn connections CSV file. AlgoHeads scans job boards and matches job openings to companies where your connections work.",
  },
  {
    question: "Is it safe to upload my LinkedIn connections file?",
    answer:
      "Yes. Your data is processed securely and is never shared or sold. We only use it to match job openings with your network.",
  },
  {
    question: "What kind of file do I need to upload?",
    answer:
      "A CSV file of your LinkedIn connections. You can export this from your LinkedIn Data Settings.",
  },
  {
    question: "Can I filter the job listings?",
    answer:
      "Yes. Filter by title, location, company, and see how many connections are at each company.",
  },
  {
    question:
      "How is this different from LinkedIn’s “Connections at this company” feature?",
    answer:
      "LinkedIn shows connections after finding a job. AlgoHeads starts with your network and finds jobs accordingly.",
  },
  {
    question: "Does AlgoHeads apply to jobs for me?",
    answer:
      "No. AlgoHeads helps you find job opportunities where you already have referral access.",
  },
  {
    question: "Is this free to use?",
    answer:
      "We’re currently offering lifetime membership for just $10.99 while we’re in beta. Prices will rise soon — grab early access now! Premium features are in the pipeline.",
  },
];

export default function Faqs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">FAQs</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
          >
            <button className="faq-question" onClick={() => toggleFaq(index)}>
              {faq.question}
              <span className="faq-toggle-icon">
                {activeIndex === index ? "–" : "+"}
              </span>
            </button>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
